exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.idx_btn_class {\r\n  margin-right: 10px;\r\n  margin-bottom: 5px;\r\n  padding: 2px;\r\n  background: #000;\r\n  color: #fff;\r\n  font-size: 12px;\r\n  height: 20px;\r\n  overflow: auto;\n}\r\n", ""]);

// exports
